/* eslint-disable */
/* global google */

const createHTMLMapMarker = ({ OverlayView = google.maps.OverlayView, ...args }) => {
	class HTMLMapMarker extends OverlayView {
	  constructor() {
		super();
		this.latlng = args.latlng;
		this.html = args.html;
		this.id = args.id;
		this.className = args.className;
		this.setMap(args.map);
	  }
  
	  createDiv() {
		this.div = document.createElement('div');
		this.div.style.position = 'absolute';
		if (this.html) this.div.innerHTML = this.html;
		if (this.id) this.div.id = this.id;
		if (this.className) this.div.className = this.className;


		google.maps.event.addDomListener(this.div, 'click', event => {
		  google.maps.event.trigger(this, 'click');
		});
	  }
  
	  appendDivToOverlay() {
		const panes = this.getPanes();
		panes.overlayImage.appendChild(this.div);
	  }
  
	  positionDiv() {
		const point = this.getProjection().fromLatLngToDivPixel(this.latlng);
		let offset = 25;
		if (point) {
		  this.div.style.left = `${point.x - offset}px`;
		  this.div.style.top = `${point.y - offset}px`;
		}
	  }

	  setPosition(newLatlng) {
		this.latlng = newLatlng;
		this.positionDiv();
	  }
  
	  draw() {
		if (!this.div) {
		  this.createDiv();
		  this.appendDivToOverlay();
		}
		this.positionDiv();
	  }
  
	  remove() {
		if (this.div) {
		  this.div.parentNode.removeChild(this.div);
		  this.div = null;
		}
	  }
  
	  getPosition() {
		return this.latlng;
	  }
  
	  getDraggable() {
		return false;
	  }
	}
  
	return new HTMLMapMarker();
};
  
export default createHTMLMapMarker;
  